// eslint-disable-next-line import/prefer-default-export
export const transform = (stockSplit) => ({
  ...stockSplit,
  date: new Date(stockSplit.date),
  updatedAt: new Date(stockSplit.updatedAt),
  createdAt: new Date(stockSplit.createdAt),
});
